import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const algolia = defineConnector({
  identifier: "algolia",
  name: "Algolia",
  tagLine: "Search and discovery platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.algolia\\.net/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "x-algolia-application-id",
        value: app.config.APP_ID,
      },
      {
        name: "x-algolia-api-key",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Algolia API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Algolia Dashboard](https://dashboard.algolia.com/account/api-keys/all), go to **Settings > API Keys**. Copy your Application ID and Admin API Key (or create a new key with the permissions you need).",
        },
      ],
    },
    {
      title: "Connect your Algolia account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Algolia instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Application ID",
          placeholder: "ERBSOWZO32",
          required: true,
          target: { kind: "configuration", field: "APP_ID" },
          helperText: "The application ID for your Algolia account",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "c5c28261f9ade4e34891ccf761491b94",
          helperText: "The API key for your Algolia account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.APP_ID}.algolia.net/1/indexes`,
  },
  publicEnvVars: ({ APP_ID }) => ({
    ALGOLIA_APP_ID: APP_ID || "",
  }),
});
